/**
 * @file       public layout component
 * @version    2.0.0
 * @author     Mehran Majidi
 * @copyright  Copyright (c) 2018, MindShare HDV LLC.  All rights reserved.
 *             Property of MindShare HDV LLC.  This file cannot be used or 
 *             altered in anyway without expressed written permission from 
 *             MindShare HDV LLC.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component
({
    selector: 'app-public-layout',
    templateUrl: './publicLayout.component.html',
    styleUrls: ['./publicLayout.component.scss'],
    standalone: false
})
class PublicLayoutComponent implements OnInit 
{
    constructor
    (
        private router : Router
    )
    {
        console.log('In Public Header');
    }
    
    ngOnInit()
    {
    }    
}

export { PublicLayoutComponent }
